import { Moon, Sun } from "@/components/ui/icons";

import { AppBarAction } from "@/components/ui/AppBarAction";
import { useColorScheme } from "@/theme/colorScheme";
import { useThemeColors, useThemeToggle } from "@/theme/theme";

/**
 * The light and dark theme switch, mounted by each theme entry point: `ScreenHeader` and
 * `FilterBar` on web, the desktop and admin sidebars, and the public show page.
 */
export function ThemeToggle() {
  const { colorScheme } = useColorScheme();
  const toggle = useThemeToggle();
  const c = useThemeColors();
  const isDark = colorScheme === "dark";
  const Glyph = isDark ? Sun : Moon;
  return (
    <AppBarAction
      onPress={toggle}
      // The label names what a tap does, which also tells a screen reader user the current theme,
      // as `CustomerFacingToggle`'s label does.
      accessibilityLabel={isDark ? "Switch to light theme" : "Switch to dark theme"}
      accessibilityRole="switch"
      accessibilityState={{ checked: isDark }}
    >
      <Glyph
        size={18}
        color={c.foreground}
      />
    </AppBarAction>
  );
}
